<kendo-pdf-export #report paperSize="A4" margin="false" forcePageBreak=".ap-report-page-break" class="ap-report-titillium">
  <ng-template kendoPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
    <!-- Footer-->
    <div class="ap-report-footer">
      <img alt="Agriport" src="../../../../assets/svg/agriport-logo.svg" class="ap-report-footer-icon">
      <div class="ap-report-footer-page">{{pageNum}} / {{totalPages}}</div>
      <div class="ap-report-footer-date">{{currentDateTime}}</div>
    </div>
  </ng-template>

  <!-- Histogram template -->
  <ng-template #histogramTemplate let-field="field" let-elementIndex="elementIndex">
    <kendo-chart #histogram renderAs="canvas" class="ap-sample-histogram-chart" [categoryAxis]="{ categories: this.statisticByField.get(field.SourceItem.Id)[elementIndex]?.data.categories }" >
      <kendo-chart-legend [visible]="false"></kendo-chart-legend>
      <kendo-chart-area background="none"></kendo-chart-area>
      <kendo-chart-value-axis>
        <kendo-chart-value-axis-item [min]="0"
                                     [max]="100"
                                     [majorUnit]="50"
                                     [color]="axisTextColor"
                                     [labels]="axisStyling" >
        </kendo-chart-value-axis-item>
      </kendo-chart-value-axis>

      <kendo-chart-category-axis>
        <kendo-chart-category-axis-item [categories]="this.statisticByField.get(field.SourceItem.Id)[elementIndex]?.data.categories"
                                        [title]="{ text: this.statisticByField.get(field.SourceItem.Id)[elementIndex]?.axes?.titleY }"
                                        [labels]="categoryStyling"
                                        [color]="axisTextColor">
        </kendo-chart-category-axis-item>
      </kendo-chart-category-axis>
      <kendo-chart-series>
        <kendo-chart-series-item
          type="column"
          [gap]="0"
          [style]="'smooth'"
          [color]="this.statisticByField.get(field.SourceItem.Id)[elementIndex].color"
          [data]="this.statisticByField.get(field.SourceItem.Id)[elementIndex].data.data">
        </kendo-chart-series-item>
      </kendo-chart-series>
    </kendo-chart>
  </ng-template>

  <ng-template #sampleGridPageBreak>
    <div class="ap-report-page-break"></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </ng-template>

  <div class="ap-sample-report-name-header">{{'Report__SoilSample' | translate}}</div>
  <!-- First page header -->
  <div class="ap-sample-basedata-grid-compact">
    <div class="ap-report-basedata-content ap-report-font ap-report-bold">{{currentFarm.FarmName}}</div>
    <div class="ap-report-align-right"></div>
    <div class="ap-report-basedata-content ap-report-font-small">{{currentFarm.StreetNo}}</div>
    <div class="ap-report-basedata-content ap-report-font-small ap-report-align-right">{{'Global__CustomerNumber' | translate}} : {{currentFarm.CustomerNumber}}</div>
    <div class="ap-report-basedata-content ap-report-font-small">{{currentFarm.ZipCode}} {{currentFarm.Town}} {{currentFarm.Country?.Id}}</div>
    <div class="ap-report-basedata-content ap-report-font-small ap-report-align-right">{{'Global__Farm_RegistryNumber' | translate}} : {{currentFarm.RegistryNumber}}</div>
  </div>
  <!-- Field level data grid -->
  <div class="ap-sample-fields-grid" *ngFor="let itemsChunk of itemsFieldLevelPerPage; let i = index" [ngClass]="i > 0 ? 'ap-report-page-break':''">
    <!--column headers-->
    <div class="ap-sample-leading-column ap-sample-fields-header-generic">{{'Global__NumberAbbr' | translate}}</div>
    <div class="ap-sample-fields-header-generic">{{'Global__FieldName' | translate}}</div>
    <div class="ap-sample-fields-header-generic">{{'Base__ManagementStyle_ha' | translate}}</div>

    <div class="ap-sample-fields-header-generic">{{'Report__SampleCount' | translate}}</div>
    <div class="ap-sample-fields-header-generic">{{'Nutrients__Region' | translate}}</div>
    <div class="ap-sample-fields-header-generic">{{'Global__SampleDate' | translate}}</div>
    <div class="ap-sample-fields-header-generic">{{'Nutrients__Soilgroup_separated' | translate}}</div>

    <div class="ap-sample-fields-header-generic ap-report-align-center ap-colspan-2">{{this.elementService.GetElementStringByString(ApElementType.P)}}</div>
    <div class="ap-sample-fields-header-generic ap-report-align-center ap-colspan-2">{{this.elementService.GetElementStringByString(ApElementType.K)}}</div>
    <div class="ap-sample-fields-header-generic ap-report-align-center ap-colspan-2">{{this.elementService.GetElementStringByString(ApElementType.Mg)}}</div>
    <div class="ap-sample-fields-header-generic ap-report-align-center ap-colspan-2">{{'Elem_Ph_short' | translate}}</div>

    <!--field content-->
    <ng-container *ngFor="let item of itemsChunk">
      <div class="ap-sample-leading-column ap-sample-fields-content-generic">{{item.NrSNr}}</div>
      <div class="ap-sample-fields-content-generic">{{item.FieldName}}</div>
      <div class="ap-sample-fields-content-generic ap-cell-align-right">{{item.Area | getRoundNumeric: digitsAfterPoint}}</div>

      <div class="ap-sample-fields-content-generic ap-cell-align-right">{{getSamplesNumber(item)}}</div>
      <div class="ap-sample-fields-content-generic">{{item.SourceItem.Region}}</div>
      <div class="ap-sample-fields-content-generic">{{item.SourceItem.SampleDate | date:'dd.MM.YYYY'}}</div>
      <div class="ap-sample-fields-content-generic ap-cell-align-center">{{item.SoilGroups}}</div>

      <div class="ap-sample-fields-content-generic ap-cell-align-right">{{displayValueWithGreaterSign(item.PValue, item.PIsGreaterE)}}</div>
      <div class="ap-sample-fields-content-generic ap-cell-align-center">{{item.SourceItem.ClassP}} </div>
      <div class="ap-sample-fields-content-generic ap-cell-align-right">{{displayValueWithGreaterSign(item.KValue, item.KIsGreaterE)}}</div>
      <div class="ap-sample-fields-content-generic ap-cell-align-center">{{item.SourceItem.ClassK}}</div>
      <div class="ap-sample-fields-content-generic ap-cell-align-right">{{displayValueWithGreaterSign(item.MgValue, item.MgIsGreaterE)}}</div>
      <div class="ap-sample-fields-content-generic ap-cell-align-center">{{item.SourceItem.ClassMg}}</div>
      <div class="ap-sample-fields-content-generic ap-cell-align-right">{{displayValueWithGreaterSign(item.PhValue, item.PhIsGreaterE)}}</div>
      <div class="ap-sample-fields-content-generic ap-cell-align-center"> {{item.SourceItem.ClassPh}}</div>
    </ng-container>

    <ng-container *ngIf="i === itemsFieldLevelPerPage.length - 1">
      <div class="ap-sample-leading-column ap-sample-fields-content-bold">{{'Global__Sum' | translate}}</div>
      <div class="ap-sample-fields-content-generic"></div>

      <div class="ap-sample-fields-content-bold ap-cell-align-right">{{getAreaSum(itemsFieldLevel) | getRoundNumeric: digitsAfterPoint}}</div>
      <div class="ap-sample-fields-content-bold ap-cell-align-right">{{getSamplesSum(itemsFieldLevel)}}</div>

      <div class="ap-sample-fields-content-generic"></div>
      <div class="ap-sample-fields-content-generic"></div>
      <div class="ap-sample-fields-content-generic"></div>
      <div class="ap-sample-fields-content-generic"></div>
      <div class="ap-sample-fields-content-generic"></div>
      <div class="ap-sample-fields-content-generic"></div>
      <div class="ap-sample-fields-content-generic"></div>
      <div class="ap-sample-fields-content-generic"></div>
      <div class="ap-sample-fields-content-generic"></div>
      <div class="ap-sample-fields-content-generic"></div>
      <div class="ap-sample-fields-content-generic"></div>
    </ng-container>
  </div>
  <div *ngIf="itemsFieldLevelPerPage.length % 2 === 1" class="ap-report-page-break"></div>
  <div class="ap-report-page-break"></div>
  <!-- Grid of all samples -->
  <div class="ap-all-samples-grid-container" *ngFor="let samplesByField of itemsSampleTrackByField; let i = index">
    <div class="ap-sample-fields-grid-all-samples">
      <div class="ap-sample-leading-column ap-sample-field-name-block ap-sample-fields-grid-full-span">{{samplesByField[0]?.SampleField?.FieldNumber}} - {{samplesByField[0]?.SampleField?.FieldPart}} {{samplesByField[0]?.SampleField?.FieldName}}</div>
      <!--column headers-->
      <div class="ap-sample-leading-column ap-sample-fields-header-generic">GPS {{'Docu_Ini__Number' | translate}}</div>
      <div class="ap-sample-fields-header-generic">{{'Global__SampleDate' | translate}}</div>
      <div class="ap-sample-fields-header-generic">{{'Nutrients__Soilgroup_separated' | translate}}</div>

      <div class="ap-sample-fields-header-generic ap-cell-align-center ap-colspan-2">{{this.elementService.GetElementStringByString(ApElementType.P)}} <br/>{{sampleMethodService.getUnitWithMethod(samplesByField[0]?.MethodP)}}</div>
      <div class="ap-sample-fields-header-generic ap-cell-align-center ap-colspan-2">{{this.elementService.GetElementStringByString(ApElementType.K)}} <br/>{{sampleMethodService.getUnitWithMethod(samplesByField[0]?.MethodK)}}</div>
      <div class="ap-sample-fields-header-generic ap-cell-align-center ap-colspan-2">{{this.elementService.GetElementStringByString(ApElementType.Mg)}} <br/>{{sampleMethodService.getUnitWithMethod(samplesByField[0]?.MethodMg)}}</div>
      <div class="ap-sample-fields-header-generic ap-cell-align-center ap-colspan-2">{{'Elem_Ph_short' | translate}} <br/>{{sampleMethodService.getUnitWithMethod(samplesByField[0]?.MethodPh)}}</div>
      <!--field content-->
      <ng-container *ngFor="let item of samplesByField; let j = index">
        <ng-container [ngTemplateOutlet]="sampleGridPageBreak" *ngIf="calculateIfPageBreakNeededForSamples(i, j + 1)"></ng-container>

        <div class="ap-sample-leading-column ap-sample-fields-content-generic">{{item.GpsNumber}}</div>
        <div class="ap-sample-fields-content-generic">{{item.SampleDate | date:'dd.MM.YYYY'}}</div>
        <div class="ap-sample-fields-content-generic ap-cell-align-center">{{item.SoilGroup}}</div>

        <div class="ap-sample-fields-content-generic ap-cell-align-right">{{displayValueByClass(this.nutrientService.convertElementOxid(item.P, ApElementOxydTypeEnum.P, item.MethodP), item.ClassP)}}</div>
        <div class="ap-sample-fields-content-generic ap-cell-align-center">{{item.ClassP}}</div>

        <div class="ap-sample-fields-content-generic ap-cell-align-right">{{displayValueByClass(this.nutrientService.convertElementOxid(item.K, ApElementOxydTypeEnum.K, item.MethodK), item.ClassK)}}</div>
        <div class="ap-sample-fields-content-generic ap-cell-align-center">{{item.ClassK}}</div>

        <div class="ap-sample-fields-content-generic ap-cell-align-right">{{displayValueByClass(this.nutrientService.convertElementOxid(item.Mg, ApElementOxydTypeEnum.Mg, item.MethodMg), item.ClassMg)}}</div>
        <div class="ap-sample-fields-content-generic ap-cell-align-center">{{item.ClassMg}}</div>

        <div class="ap-sample-fields-content-generic ap-cell-align-right">{{displayValueByClass(item.Ph, item.ClassPh)}}</div>
        <div class="ap-sample-fields-content-generic ap-cell-align-center">{{item.ClassPh}}</div>
      </ng-container>
    </div>
    <!-- Adding empty page in case of even amount of sample pages -->
    <div class="ap-report-page-break" *ngIf="Math.ceil(samplesByField.length / this.samplesPerPageCount) % 2 === 0"></div>
    <div class="ap-report-page-break"></div>
    <ng-container *ngIf="itemsFieldLevel && itemsFieldLevel.length > 0">
      <!-- P and K Page -->
      <div class="ap-sample-fields-map-grid-full-page">
        <div class="ap-sample-fields-map-info-header">
          <div class="ap-report-bold ap-cell-align-left">{{itemsFieldLevel[getFieldIndex(i)].FieldNumber}} - {{itemsFieldLevel[getFieldIndex(i)].FieldPart}} {{itemsFieldLevel[getFieldIndex(i)].FieldName}}</div>
          <div>{{itemsFieldLevel[getFieldIndex(i)].Area}} {{'Base__ManagementStyle_ha' | translate}}</div>
          <div>{{getLandUseTranslation(itemsFieldLevel[getFieldIndex(i)].SourceItem.LandUse)}}</div>
          <div>{{itemsFieldLevel[getFieldIndex(i)].SampleDate | date:'dd.MM.YYYY'}}</div>
          <div>{{'Nutrients__Region' | translate}}: {{itemsFieldLevel[getFieldIndex(i)].SourceItem.Region}}</div>
        </div>
        <div class="ap-sample-field-map-placeholder">
          <ap-layer-export *ngIf="i * 6 - renderedMaps < 100" [featureId]="itemsFieldLevel[getFieldIndex(i)].SourceItem.Id" [sourceLayer]="soilSampleFieldLayer"
                           [featureUrl]="getFeatureUrl(itemsFieldLevel[getFieldIndex(i)], 0)" [featureColorPropertyName]="'ClassP'"
                           [textPropertyPrecision]="1" [textPropertyFunction]="oxideTransformation"
                           [textPropertyFunctionParam]="{elem: ApElementOxydTypeEnum.P, method: itemsFieldLevel[getFieldIndex(i)].SourceItem.MethodP}"
                           [overlayUrl]="getSampleTrackMapUrl(itemsFieldLevel[getFieldIndex(i)])" [overlayTextPropertyName]="'p'"
                           (renderCompleted)="onRenderCompleted()" class="ap-reports-map"></ap-layer-export>
        </div>
        <div class="ap-sample-field-info-histogram">
          <div class="ap-sample-field-info-element-block ap-report-border-bottom">
            <div class="ap-vertical-align ap-report-font-medium-large ap-report-bold ap-cell-align-left">{{this.elementService.GetElementStringByString(ApElementType.P)}}</div>
            <div class="ap-vertical-align-up ap-report-font-medium ap-report-align-left">{{itemsFieldLevel[getFieldIndex(i)].SourceItem.ClassP}}</div>
            <div class="ap-vertical-align-down ap-report-font-medium ap-report-align-left">Ø {{displayAvgValueWithGreaterSign(itemsFieldLevel[getFieldIndex(i)].PValue, itemsFieldLevel[getFieldIndex(i)].PIsGreaterE)}}</div>
            <div></div>
            <div class="ap-report-font-small ap-cell-align-left ap-report">{{sampleMethodService.getUnitWithMethod(itemsFieldLevel[getFieldIndex(i)].SourceItem.MethodP)}}</div>
          </div>
          <div class="ap-report-border-bottom ap-report-border-right">
            <ng-container [ngTemplateOutlet]="histogramTemplate"
                          [ngTemplateOutletContext]="{field: itemsFieldLevel[getFieldIndex(i)], elementIndex: 0}">
            </ng-container>
          </div>

          <div class="ap-sample-field-info-element-block ap-report-border-top">
            <div class="ap-vertical-align ap-report-font-medium-large ap-report-bold ap-cell-align-left">{{this.elementService.GetElementStringByString(ApElementType.K)}}</div>
            <div class="ap-vertical-align-up ap-report-font-medium ap-report-align-left">{{itemsFieldLevel[getFieldIndex(i)].SourceItem.ClassK}}</div>
            <div class="ap-vertical-align-down ap-report-font-medium ap-report-align-left">Ø {{displayAvgValueWithGreaterSign(itemsFieldLevel[getFieldIndex(i)].KValue, itemsFieldLevel[getFieldIndex(i)].KIsGreaterE)}}</div>
            <div></div>
            <div class="ap-report-font-small ap-cell-align-left ap-report">{{sampleMethodService.getUnitWithMethod(itemsFieldLevel[getFieldIndex(i)].SourceItem.MethodK)}}</div>
          </div>
          <div class="ap-report-border-top">
            <ng-container [ngTemplateOutlet]="histogramTemplate"
                          [ngTemplateOutletContext]="{field: itemsFieldLevel[getFieldIndex(i)], elementIndex: 1}">
            </ng-container>
          </div>
        </div>
        <div class="ap-sample-field-map-placeholder">
          <ap-layer-export *ngIf="i * 6 - renderedMaps < 100" [featureId]="itemsFieldLevel[getFieldIndex(i)].SourceItem.Id" [sourceLayer]="soilSampleFieldLayer"
                           [featureUrl]="getFeatureUrl(itemsFieldLevel[getFieldIndex(i)], 1)" [featureColorPropertyName]="'ClassK'"
                           [textPropertyPrecision]="1" [textPropertyFunction]="oxideTransformation"
                           [textPropertyFunctionParam]="{elem: ApElementOxydTypeEnum.K, method: itemsFieldLevel[getFieldIndex(i)].SourceItem.MethodK}"
                           [overlayUrl]="getSampleTrackMapUrl(itemsFieldLevel[getFieldIndex(i)])" [overlayTextPropertyName]="'k'"
                           (renderCompleted)="onRenderCompleted()" class="ap-reports-map"></ap-layer-export>
        </div>
      </div>
      <div class="ap-report-page-break"></div>
      <!-- Mg and Ph Page -->
      <div class="ap-sample-fields-map-grid-full-page">
        <div class="ap-sample-fields-map-info-header">
          <div class="ap-report-bold ap-cell-align-left">{{itemsFieldLevel[getFieldIndex(i)].FieldNumber}} - {{itemsFieldLevel[getFieldIndex(i)].FieldPart}} {{itemsFieldLevel[getFieldIndex(i)].FieldName}}</div>
          <div>{{itemsFieldLevel[getFieldIndex(i)].Area}} {{'Base__ManagementStyle_ha' | translate}}</div>
          <div>{{getLandUseTranslation(itemsFieldLevel[getFieldIndex(i)].SourceItem.LandUse)}}</div>
          <div>{{itemsFieldLevel[getFieldIndex(i)].SampleDate | date:'dd.MM.YYYY'}}</div>
          <div>{{'Nutrients__Region' | translate}}: {{itemsFieldLevel[getFieldIndex(i)].SourceItem.Region}}</div>
        </div>
        <div class="ap-sample-field-map-placeholder">
          <ap-layer-export *ngIf="i * 6 - renderedMaps < 100" [featureId]="itemsFieldLevel[getFieldIndex(i)].SourceItem.Id" [sourceLayer]="soilSampleFieldLayer"
                           [featureUrl]="getFeatureUrl(itemsFieldLevel[getFieldIndex(i)], 2)" [featureColorPropertyName]="'ClassMg'"
                           [textPropertyPrecision]="1" [textPropertyFunction]="oxideTransformation"
                           [textPropertyFunctionParam]="{elem: ApElementOxydTypeEnum.Mg, method: itemsFieldLevel[getFieldIndex(i)].SourceItem.MethodMg}"
                           [overlayUrl]="getSampleTrackMapUrl(itemsFieldLevel[getFieldIndex(i)])" [overlayTextPropertyName]="'mg'"
                           (renderCompleted)="onRenderCompleted()" class="ap-reports-map"></ap-layer-export>
        </div>
        <div class="ap-sample-field-info-histogram">
          <div class="ap-sample-field-info-element-block ap-report-border-bottom">
            <div class="ap-vertical-align ap-report-font-medium-large ap-report-bold ap-cell-align-left">{{this.elementService.GetElementStringByString(ApElementType.Mg)}}</div>
            <div class="ap-vertical-align-up ap-report-font-medium ap-report-align-left">{{itemsFieldLevel[getFieldIndex(i)].SourceItem.ClassMg}}</div>
            <div class="ap-vertical-align-down ap-report-font-medium ap-report-align-left">Ø {{displayAvgValueWithGreaterSign(itemsFieldLevel[getFieldIndex(i)].MgValue, itemsFieldLevel[getFieldIndex(i)].MgIsGreaterE)}}</div>
            <div></div>
            <div class="ap-report-font-small ap-cell-align-left ap-report">{{sampleMethodService.getUnitWithMethod(itemsFieldLevel[getFieldIndex(i)].SourceItem.MethodMg)}}</div>
          </div>
          <div class="ap-report-border-bottom ap-report-border-right">
            <ng-container [ngTemplateOutlet]="histogramTemplate"
                          [ngTemplateOutletContext]="{field: itemsFieldLevel[getFieldIndex(i)], elementIndex: 2}">
            </ng-container>
          </div>

          <div class="ap-sample-field-info-element-block ap-report-border-top">
            <div class="ap-vertical-align ap-report-font-medium-large ap-report-bold ap-cell-align-left">{{'Elem_Ph_short' | translate}}</div>
            <div class="ap-vertical-align-up ap-report-font-medium ap-report-align-left">{{itemsFieldLevel[getFieldIndex(i)].SourceItem.ClassPh}}</div>
            <div class="ap-vertical-align-down ap-report-font-medium ap-report-align-left">Ø {{displayAvgValueWithGreaterSign(itemsFieldLevel[getFieldIndex(i)].PhValue, itemsFieldLevel[getFieldIndex(i)].PhIsGreaterE)}}</div>
            <div></div>
            <div class="ap-report-font-small ap-cell-align-left ap-report">{{sampleMethodService.getUnitWithMethod(itemsFieldLevel[getFieldIndex(i)].SourceItem.MethodPh)}}</div>
          </div>
          <div class="ap-report-border-top">
            <ng-container [ngTemplateOutlet]="histogramTemplate"
                          [ngTemplateOutletContext]="{field: itemsFieldLevel[getFieldIndex(i)], elementIndex: 3}">
            </ng-container>
          </div>
        </div>
        <div class="ap-sample-field-map-placeholder">
          <ap-layer-export *ngIf="i * 6 - renderedMaps < 100" [featureId]="itemsFieldLevel[getFieldIndex(i)].SourceItem.Id" [sourceLayer]="soilSampleFieldLayer"
                           [featureUrl]="getFeatureUrl(itemsFieldLevel[getFieldIndex(i)], 3)" [featureColorPropertyName]="'ClassPh'"
                           [textPropertyPrecision]="1"
                           [overlayUrl]="getSampleTrackMapUrl(itemsFieldLevel[getFieldIndex(i)])" [overlayTextPropertyName]="'ph'"
                           (renderCompleted)="onRenderCompleted()" class="ap-reports-map"></ap-layer-export>
        </div>
      </div>
      <div class="ap-report-page-break"></div>
      <!-- Sample tracks and Soil Group -->
      <div class="ap-sample-fields-map-grid-full-page">
        <div class="ap-sample-fields-map-info-header">
          <div class="ap-report-bold ap-cell-align-left">{{itemsFieldLevel[getFieldIndex(i)].FieldNumber}} - {{itemsFieldLevel[getFieldIndex(i)].FieldPart}} {{itemsFieldLevel[getFieldIndex(i)].FieldName}}</div>
          <div>{{itemsFieldLevel[getFieldIndex(i)].Area}} {{'Base__ManagementStyle_ha' | translate}}</div>
          <div>{{getLandUseTranslation(itemsFieldLevel[getFieldIndex(i)].SourceItem.LandUse)}}</div>
          <div>{{itemsFieldLevel[getFieldIndex(i)].SampleDate | date:'dd.MM.YYYY'}}</div>
          <div>{{'Nutrients__Region' | translate}}: {{itemsFieldLevel[getFieldIndex(i)].SourceItem.Region}}</div>
        </div>
        <div class="ap-sample-field-map-placeholder ap-sample-track-map">
          <ap-layer-export *ngIf="i * 6 - renderedMaps < 100" [featureId]="itemsFieldLevel[getFieldIndex(i)].SourceItem.Id" [sourceLayer]="soilSampleFieldLayer"
                           [featureUrl]="getSampleTrackMapUrl(itemsFieldLevel[getFieldIndex(i)])" [textProperty]="'gpsnumber'" [textPropertyFont]="'bold 26px Titillium Web, sans-serif'"
                           (renderCompleted)="onRenderCompleted()" class="ap-reports-map"></ap-layer-export>
        </div>
        <div class="ap-sample-soil-group-legend-chart-block">
          <div class="ap-vertical-align ap-report-align-left ap-report-font-medium ap-report-bold ap-report-border-bottom ap-report-border-right">{{'DataContext_InterfaceMapping__Samples' | translate}}</div>

          <div class="ap-text-container ap-report-border-top">
            <span class="ap-report-font-medium ap-report-bold">{{'Nutrients__Soilgroup' | translate}}</span>
          </div>
          <div class="ap-report-border-top">
            <kendo-chart renderAs="canvas" class="ap-sample-soil-group-legend-chart" [categoryAxis]="{ categories: this.soilGroupChartData.categories }">
              <kendo-chart-legend [visible]="false"></kendo-chart-legend>
              <kendo-chart-area background="none"></kendo-chart-area>
              <kendo-chart-value-axis>
                <kendo-chart-value-axis-item [visible]="false" [max] = 1></kendo-chart-value-axis-item>
              </kendo-chart-value-axis>
              <kendo-chart-category-axis>
                <kendo-chart-category-axis-item [color]="axisTextColor"
                                                [categories]="this.soilGroupChartData.categories"
                                                [labels]="categoryStyling">
                </kendo-chart-category-axis-item>
              </kendo-chart-category-axis>

              <kendo-chart-series>
                <kendo-chart-series-item
                  type="column"
                  [gap]="0"
                  [style]="'smooth'"
                  [color]="this.soilGroupChartData.colorFunc"
                  [data]="this.soilGroupChartData.values">
                </kendo-chart-series-item>
              </kendo-chart-series>
            </kendo-chart>
          </div>
        </div>
        <div class="ap-sample-field-map-placeholder ap-soil-sample-map">
          <ap-layer-export *ngIf="i * 6 - renderedMaps < 100" [featureId]="itemsFieldLevel[getFieldIndex(i)].SourceItem.Id" [sourceLayer]="soilSampleFieldLayer"
                           [featureUrl]="getSoilGroupMapUrl(itemsFieldLevel[getFieldIndex(i)])" [featureColorPropertyName]="'SoilGroup'" [featureColorsArray]="soilGroupChartData.colorValues"
                           (renderCompleted)="onRenderCompleted()" class="ap-reports-map"></ap-layer-export>
        </div>
      </div>
      <div *ngIf="i < itemsSampleTrackByField.length - 1" class="ap-report-page-break"></div>
    </ng-container>
  </div>

</kendo-pdf-export>
